export function checkPermissions() {
    if(localStorage.getItem('user') != null) {
        let user = JSON.parse(localStorage.getItem('user'));

        if (user.is_guest == true){
            return true;
        }
        return false;
    }
}